<!-- Hidden icons for Material Icons -->
<mat-icon fontSet="material-icons-outlined" style="display: none;">people</mat-icon>
<mat-icon fontSet="material-icons-outlined" style="display: none;">directions_car</mat-icon>
<mat-icon fontSet="material-icons-outlined" style="display: none;">access_time</mat-icon>
<mat-icon fontSet="material-icons-outlined" style="display: none;">trending_up</mat-icon>

<!-- Back Button for Mobile Filter View -->
<div class="back-button" *ngIf="isMobile && isVisible">
    <button (click)="goBack()">
        <div class="back-button-icon">
            <mat-icon>arrow_back</mat-icon>
            <span class="back-button-text">Filter</span>
        </div>
    </button>
</div>

<div class="cab-search-header" [ngStyle]="{'margin-top': getMarginTop()}">
    <div class="cab-search-desktop-header" *ngIf="!isMobile">
        <span class="cab-search-title">Available Cabs</span>
    </div>
    <div class="cab-search-mobile-header" *ngIf="isMobile && !isVisible">
        <span class="cab-search-title">Available Cabs</span>
        <div class="filter-icon">
            <button mat-button (click)="openMobileFilter()">
                <img  src="assets/filter.svg" alt="Logo" class="logo-img" />
                Filter
            </button>
        </div>
    </div>

    <input *ngIf="isMobile && !isVisible" type="text" placeholder="Search" class="search-input" [(ngModel)]="searchTerm"
        (ngModelChange)="filterPackages($event)" />
    <div class="cab-search-tabs" *ngIf="isVisible">
        <app-trip-type-tabs [(value)]="selectedTripType" (valueChange)="setTripType($event)"></app-trip-type-tabs>
    </div>
</div>

<div class="booking-details">
    <div class="desktop-view">
        <div class="cab-search-bar" *ngIf="isVisible">
            <app-trip-search-form #tripSearchForm [pageType]="'bookingSearch'" [selectedTripType]="selectedTripType"
                [data]="searchFormData"></app-trip-search-form>
        </div>
        <div class="booking-search-list" *ngIf="isSearchListVisible">
            <mat-card class="booking-card" *ngFor="let pkg of filteredPackages">
                <div class="booking-card-row">
                    <div class="car-image">
                        <div class="mobile-card-header">
                            <span class="car-badge">{{ pkg.vehicleName }}</span>
                            <mat-icon color="primary" class="info-icon" [matTooltip]="pkg.vehicleType || 'Vehicle Info'" matTooltipTouchGestures="auto">info</mat-icon>
                        </div>
                        <img [src]="pkg.vehicleImage" [alt]="pkg.vehicleName" />
                    </div>
                    <div class="car-info">
                        <div class="car-title-row">
                            <div class="car-name-row">
                                <span class="car-name">{{ pkg.vehicleName }}</span>
                                <mat-icon color="primary" class="info-icon"  [matTooltip]="pkg.vehicleType || 'Vehicle Info'">info</mat-icon>
                            </div>
                            <span class="package-label">Package: {{ pkg.packageName }}</span>
                        </div>
                        <div class="car-details-extras">
                            <div class="details-col">




                                <div class="detail-row">
                                    <img src="assets/basic_Km.svg" alt="car">
                                    <span>Basic KMS: </span>
                                    <span class="extra-value same-align">{{ pkg.basicKM }}</span>
                                </div>
                                <div class="detail-row">
                                    <img src="assets/time_Icon.svg" alt="car">
                                    <span>Basic Hrs: </span>
                                    <span class="extra-value same-align">{{ pkg.basicHrs }}</span>
                                </div>
                                <div class="detail-row">
                                    <img src="assets/ExtraPerKm.svg" alt="car">
                                    <span>Extra per Km:</span>
                                    <span class="extra-value">₹ {{ pkg.extraPerKm }}</span>
                                </div>
                                <div class="detail-row">
                                    <img src="assets/ExtraPerHrs.svg" alt="car">
                                    <span>Extra per Hrs:</span>
                                    <span class="extra-value">₹ {{ pkg.extraHrs }}</span>
                                </div>
                            </div>
                            <div class="extras-col">


                                <div class="detail-row">
                                    <img src="assets/sitting_Capacity.svg" alt="car">
                                    <span>Seating Capacity: </span>
                                    <span class="extra-value">{{ pkg.seatingCapacity }}</span>
                                </div>
                                <div class="detail-row">
                                    <img src="assets/parking_Icon.svg" alt="car">
                                    <span>Parking Charges: </span>
                                    <span class="extra-value">{{ pkg.parkingIncExc }}</span>
                                </div>

                                <div class="detail-row">
                                    <img src="assets/toll_Icon.svg" alt="car">
                                    <span>Toll Charges: </span>
                                    <span class="extra-value toll-charges">{{ pkg.tollIncExc }}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="package-amount">
                        <div class="package-amount-row">
                            <div class="amount-label">Package Amount</div>
                            <div class="amount-value">₹{{ pkg.totalFare | number:'1.2-2' }}<span class="gst">+GST</span>
                            </div>
                        </div>
                        <div class="action-buttons">
                            <button mat-stroked-button color="primary" (click)="showEstimateTotal(pkg)">Estimated
                                Total</button>
                            <button mat-raised-button color="primary" (click)="bookNow(pkg)">Book Now</button>
                        </div>
                    </div>
                </div>
            </mat-card>

        </div>
    </div>

</div>
@if(isMobile){
<div class="fixed-bottom-navigation">
    <app-navigation-tabs [activeTab]="'available-cabs'" (tabChange)="onTabChange($event)">
    </app-navigation-tabs>
</div>
}

<!-- Estimate Total Modal -->
<div class="estimate-modal-overlay" *ngIf="showEstimateModal" (click)="closeEstimateModal()">
    <div class="estimate-modal" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="modal-header">
            <div class="header-content">
                <h2 class="modal-title">Estimated Total</h2>
                <button class="close-button" (click)="closeEstimateModal()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
            <!-- Cost Breakdown -->
            <div class="cost-breakdown-section">
                <div class="cost-items">
                    <div class="cost-item">
                        <span class="cost-label">Package Amount:</span>
                        <span class="cost-value">₹{{ selectedPackage?.totalFare | number:'1.2-2' }}</span>
                    </div>
                    <div class="cost-item">
                        <span class="cost-label">GST (5%):</span>
                        <span class="cost-value">₹{{ (selectedPackage?.totalFare * 0.05) | number:'1.2-2' }}</span>
                    </div>
                    <div class="cost-item total">
                        <span class="cost-label">Total Amount:</span>
                        <span class="cost-value">₹{{ (selectedPackage?.totalFare * 1.05) | number:'1.2-2' }}</span>
                    </div>
                    <div class="cost-item">
                        <span class="cost-label">Extra Per Km:</span>
                        <span class="cost-value">₹{{ selectedPackage?.extraPerKm | number:'1.2-2'}}</span>
                    </div>
                    <div class="cost-item">
                        <span class="cost-label">Extra Per Hr:</span>
                        <span class="cost-value">₹{{ selectedPackage?.extraHrs | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>

            <!-- Additional Information -->
            <div class="additional-info-section">
                <p>
                    <span [innerHTML]="selectedPackage?.b2CTermsAndConditions"></span>
                </p>
            </div>
        </div>
    </div>
</div>